import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronDown,
  faChevronRight,
  IconDefinition,
} from '@fortawesome/pro-light-svg-icons';

interface SidebarChild {
  key: string;
  label: string;
  icon: IconDefinition;
  onClick?: () => void;
}

interface Props {
  label: string;
  icon?: IconDefinition;
  onClick?: () => void;
  isActive?: boolean;
  childItems?: SidebarChild[];
  activeChildKey?: string;
}

const SidebarItem = ({
  onClick,
  isActive,
  label,
  childItems,
  icon,
  activeChildKey,
}: Props) => {
  return (
    <div className="w-full">
      <div
        onClick={onClick}
        className={`hover:bg-gray-100 ${isActive ? 'text-[var(--theme-primary)]' : ''} cursor-pointer rounded-xl p-2 px-3 flex space-x-2 items-center`}
      >
        <div className="w-3">
          {childItems && (
            <FontAwesomeIcon
              icon={isActive ? faChevronDown : faChevronRight}
              size="xs"
            />
          )}
          {!childItems && icon && <FontAwesomeIcon icon={icon} size="xs" />}
        </div>
        <span>{label}</span>
      </div>

      {childItems && (
        <div
          className="pl-4"
          style={{
            display: isActive ? 'block' : 'none',
          }}
        >
          {childItems.map((child) => (
            <div
              key={child.key}
              onClick={child.onClick}
              className={`hover:bg-gray-100 ${child.key === activeChildKey ? 'text-[var(--theme-primary)]' : ''} cursor-pointer rounded-xl p-2 px-3 flex space-x-2 items-center text-sm`}
            >
              <div className="w-3">
                <FontAwesomeIcon icon={child.icon} />
              </div>
              <span>{child.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
